import React, { useEffect, useState } from 'react'
import { Button, Form, Input, message, Modal } from 'antd'
import validator from '../../validator'
import departmentStore from '../../stores/departmentStore'
import authenticationStore from '../../stores/authenticationStore'
import { MODAL_MODE } from '../../ui_constants'
import {
  CreateDepartmentModalGlobalStyle,
  CreateDepartmentModalWrapper,
  ModalFooterGroup,
} from './CreateDepartmentModalStyled'

const CreateDepartmentModal = createDepartmentModalProps => {
  const {
    setCheckUpdate,
    isVisibleCreateDepartmentModal,
    mode,
    handleCloseCreateDepartmentModal,
    currentDepartment,
  } = createDepartmentModalProps

  const [isLoading, setIsLoading] = useState(false)
  const [initialValue, setInitialValue] = useState('')

  const [form] = Form.useForm()

  useEffect(() => {
    const fetchData = async () => {
      if (isVisibleCreateDepartmentModal && mode === MODAL_MODE.UPDATE) {
        setInitialValue(currentDepartment?.name)
        await form.setFieldsValue({
          name: currentDepartment?.name,
        })
      } else {
        form.setFieldsValue({
          name: '',
        })
      }
    }

    fetchData()
  }, [isVisibleCreateDepartmentModal, mode])

  const onFinish = async values => {
    try {
      setIsLoading(true)

      const { name } = values
      if (mode === MODAL_MODE.UPDATE) {
        if (name.trim() !== currentDepartment.name)
          await departmentStore.update(currentDepartment.code, name)
      } else {
        await departmentStore.create(name)
      }

      closeAndResetForm()

      message.success(
        `${
          mode === MODAL_MODE.UPDATE ? `Chỉnh sửa` : `Tạo mới`
        } phòng ban thành công`
      )
      setCheckUpdate(true)
      await departmentStore.getAllDepartmentList(
        authenticationStore.currentCompanyCode()
      )
    } catch (e) {
      if (
        (e.errorCode && e.errorCode === 'DEPARTMENT-102') ||
        (e.vi && e.vi === 'Đã có lỗi xảy ra trong quá trình kết nối!') ||
        (e.errorCode && e.errorCode === 'API-501')
      ) {
        message.error('Tên phòng ban đã tồn tại')
      } else {
        message.error('Đã có lỗi xảy ra!')
      }
    } finally {
      setIsLoading(false)
      setCheckUpdate(false)
    }
  }

  const closeAndResetForm = () => {
    form.resetFields()
    form.setFieldsValue({
      name: initialValue,
    })
    handleCloseCreateDepartmentModal()
  }

  return (
    <Modal
      className="create-department-modal"
      title={`${
        mode === MODAL_MODE.UPDATE ? `Chỉnh sửa` : `Tạo mới`
      } phòng ban`}
      footer={null}
      closable={true}
      visible={isVisibleCreateDepartmentModal}
      onCancel={closeAndResetForm}>
      <CreateDepartmentModalGlobalStyle />
      <CreateDepartmentModalWrapper>
        <Form form={form} layout={'vertical'} onFinish={onFinish}>
          <Form.Item
            name={'name'}
            rules={[
              { required: true, message: 'Vui lòng nhập tên phòng ban!' },
              { validator: validator.validateInputString },
            ]}
            label={'Tên phòng ban:'}>
            <Input placeholder={'Nhập tên phòng ban'} />
          </Form.Item>

          <ModalFooterGroup>
            <Button
              className="btn-cancel"
              htmlType="button"
              onClick={closeAndResetForm}>
              Hủy
            </Button>
            <Button
              className="btn-submit"
              loading={isLoading}
              htmlType={'submit'}
              type={'primary'}>
              {mode === MODAL_MODE.UPDATE ? `Chỉnh sửa` : `Tạo mới`}
            </Button>
          </ModalFooterGroup>
        </Form>
      </CreateDepartmentModalWrapper>
    </Modal>
  )
}

CreateDepartmentModal.propTypes = {}

export default CreateDepartmentModal
